export default __webpack_public_path__ + "static/media/world-atlas-1-rMIN.b4810524.jpg";